import React from 'react';
import { motion } from 'framer-motion';
import { PlanSelector } from '../ui/PlanSelector';
import { ShieldCheck, Clock, CreditCard } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 md:py-24 bg-[#FBF7F0] relative overflow-hidden" data-id="element-97">
      <div className="absolute inset-0 bg-[#E76F51]/5 transform -skew-y-2 origin-top-left" data-id="element-98"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-99">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-100">
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#1E2A4A] mb-4 md:mb-6" data-id="element-101">
            No dejes pasar esta oportunidad
          </h2>

          <p className="text-base md:text-xl text-[#1E2A4A]/80 mb-6 md:mb-8 max-w-2xl mx-auto" data-id="element-102">
            Empezá hoy mismo a transformar el día a día con tu hijo. Elegí tu
            opción y empezá en minutos.
          </p>

          <div className="mb-6 md:mb-8" data-id="element-103">
            <PlanSelector data-id="element-104" />
          </div>

          <div className="flex flex-wrap justify-center items-center gap-x-4 md:gap-x-6 gap-y-2 md:gap-y-3 text-xs md:text-sm text-[#1E2A4A]/70 font-semibold" data-id="element-105">
            <span className="flex items-center gap-1 md:gap-1.5" data-id="element-106">
              <ShieldCheck size={16} className="text-[#8A9A86] md:w-[18px] md:h-[18px]" data-id="element-107" />{' '}
              Pago seguro
            </span>
            <span className="hidden sm:inline text-gray-300" data-id="element-108">|</span>
            <span className="flex items-center gap-1 md:gap-1.5" data-id="element-109">
              <Clock size={16} className="text-[#8A9A86] md:w-[18px] md:h-[18px]" data-id="element-110" />{' '}
              Acceso en 5 min
            </span>
            <span className="hidden sm:inline text-gray-300" data-id="element-111">|</span>
            <span className="flex items-center gap-1 md:gap-1.5" data-id="element-112">
              <ShieldCheck size={16} className="text-[#8A9A86] md:w-[18px] md:h-[18px]" data-id="element-113" />{' '}
              Garantía 7 días
            </span>
            <span className="hidden sm:inline text-gray-300" data-id="element-114">|</span>
            <span className="flex items-center gap-1 md:gap-1.5" data-id="element-115">
              <CreditCard size={16} className="text-[#8A9A86] md:w-[18px] md:h-[18px]" data-id="element-116" />{' '}
              Mercado Pago
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}